import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import CampLejeuneApplicationWrapper from "@components/layouts/campLejeuneApplicationWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <CampLejeuneApplicationWrapper footerBgColor="#fff">
            <div className="bg-white">
                <ContactTop iconsFillColor="#bf2628" />
            </div>
            <FormSection iconsFillColor="#bf2628" />
        </CampLejeuneApplicationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
